export enum DatasheetTabNameManagementMode {
  add = "add",
  rename = "rename",
  paste = "paste",
};

export type DatasheetTabNameManagementSubmitParams = {
  tabName: string;
};

export type DatasheetTabNameManagementProps = {
  onClose: () => void;
  onSubmit: (params: DatasheetTabNameManagementSubmitParams) => void;
  mode: DatasheetTabNameManagementMode;
};

export type DatasheetTabNameManagementConfig = {
  title: string;
};
